import * as React from 'react';
import {Reducer, useEffect, useReducer, useState} from 'react';

interface Option {
    label;
}

interface Props {
    onChange?;
    value: string;
}

export const AnswersField = (props: Props) => {
    const [options, dispatch] = useReducer<Reducer<Option[], any>>((options, { type, value, changedValue }) => {
        switch (type) {
            case "add":
                return [...options, value];
            case "remove":
                return options.filter((_, index) => index !== value);
            case "update":
                return options.map((_, index) => {
                    if (index === value) {
                        return changedValue;
                    }

                    return _;
                });
            default:
                return options;
        }
    }, (props.value || '').split(',').map(item => {
        return {
            label: item.trim().substr(1, item.length - 2)
        };
    }));

    useEffect(() => {
        props.onChange(options.filter(item => item.label.length).map(item => `[${item.label}]`).join(','));
    });

    return <>
        { options.map((option, index) => {
            const isLast = index >= options.length - 1;

            return <div className="input-group mb-2" key={index}>
                <input
                    type="text"
                    onChange={e => {
                        if (isLast) {
                            dispatch({ type: "add", value: { label: '' }});
                        }

                        dispatch({ type: "update", value: index, changedValue: { label: e.currentTarget.value } });
                    }}
                    className="form-control skip-validation"
                    value={option.label}
                    placeholder="Enter option value..." />

                { !isLast ? (
                    <div className="input-group-append">
                        <button
                            onClick={e => {
                                dispatch({ type: "remove", value: index });
                            }}
                            className="btn btn-outline-secondary">Remove</button>
                    </div>
                ) : (
                    <div className="input-group-append">
                        <button className="btn btn-outline-secondary" onClick={e => {
                            dispatch({ type: "add", value: { label: '' }})
                        }}>Add</button>
                    </div>
                ) }
            </div>;
        }) }
    </>;
};
